import React from 'react';

export interface PatientFormMediaContextValue {
  submissionId?: string;
  assignmentId?: string;
  accessToken?: string;
  /** blockId → signed S3 URL from `submission.media.files` or block `value_url`. */
  fileUrlsByBlockId?: Record<string, string>;
  /** file_key → signed S3 URL from `submission.media.files`. */
  fileUrlsByKey?: Record<string, string>;
  /** blockId → signed S3 URL for `signature_pad` blocks. */
  signatureUrlsByBlockId?: Record<string, string>;
}

export const PatientFormMediaContext = React.createContext<PatientFormMediaContextValue>({});

export function usePatientFormMedia(): PatientFormMediaContextValue {
  return React.useContext(PatientFormMediaContext);
}
